import React, {useContext} from "react";
import {Fade} from "react-reveal";
import {Link} from "react-router-dom";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {illustration, greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import {useSettings} from "../../contexts/SettingsContext";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  const {isVisible} = useSettings();
  // Admin controls visibility from /admin → Settings → "Resume — PDF download".
  const showDownload = isVisible("sections.resumePdf");
  if (!greeting.displayGreeting) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />
                {showDownload && (
                  // Same visual Button as the Resume page. Navigates to /resume
                  // with ?download=1, where the page auto-fires window.print()
                  // once the admin-edited content is rendered. No static file,
                  // no external URL — the PDF is the live admin-managed resume.
                  <Link to="/resume?download=1" className="download-link-button">
                    <Button text="Download my resume" />
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt="man sitting on table"
                src={require("../../assets/images/manOnTable.svg")}
              ></img>
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
